import { render, staticRenderFns } from "./RiskAddressScrubbingSuccessModal.vue?vue&type=template&id=03a4d6b8"
import script from "./RiskAddressScrubbingSuccessModal.vue?vue&type=script&lang=ts"
export * from "./RiskAddressScrubbingSuccessModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports